/**
 * Device Operations Date Cell - Frontend
 * @description Cell component for displaying operation date (localized with operation tz when available)
 */

import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { DashboardOperation } from '@/types/dashboard.types';
import { formatDateAsYearMonthDayHourMinute } from '@/utils/formatters/dateFormatter';

export const DeviceOperationsDateCell: React.FC<{
  info: CellContext<DashboardOperation, string>;
  field: string;
}> = ({ info, field }) => {
  const row = info.row.original;
  const fieldValue = row[field as keyof DashboardOperation];
  const ts = fieldValue as string | undefined;
  const tz = row.tz;

  return (
    <div className="text-xs">
      <div className="flex items-center gap-1 text-gray-900">
        {ts ? formatDateAsYearMonthDayHourMinute(ts, tz) : 'Unknown'}
      </div>
    </div>
  );
};
